import React from "react";
import LayoutContent from "../components/LayoutContent";
import DecorativeLines from "../components/DecorativeLines";

const CustomLogin = ({ onLoginSuccess }) => {
    const logo_header = window.themes?.logo || window.welcome?.logo_welcome;
    const title =
        window.login_page?.title ||
        window.welcome?.title_welcome ||
        "ASML RBA Security Leadership";
    const subtitle = window.welcome?.subtitle_welcome || "WELCOME TO";
    const buttonText = window.login_page?.button_text || "Login with SSO";

    const loginImages = window.login_page?.gallery_overlay;

    const handleLoginClick = (e) => {
        e.preventDefault();
        console.log(onLoginSuccess);
        if (onLoginSuccess) {
            onLoginSuccess();
        } else if (window.themes?.login_url) {
            window.location.href = window.themes.login_url;
        }
    };

    return (
        <LayoutContent>
            <div className="CustomLogin">
                {/* Reusable Sliced Decorative Accent Lines Component */}
                <DecorativeLines variant="login" label="LOGIN" />

                <div className="CustomLogin__logo">
                    {logo_header ? (
                        <img
                            className="CustomLogin__logo--img"
                            alt="logo"
                            src={logo_header}
                        />
                    ) : (
                        <span className="CustomLogin__logo--text">ASML</span>
                    )}
                </div>

                <div className="CustomLogin__container">
                    <div className="CustomLogin__content">
                        <header className="CustomLogin__header">
                            <span className="CustomLogin__subtitle">
                                {subtitle}
                            </span>
                            <h1 className="CustomLogin__title">{title}</h1>
                        </header>
                        <div className="CustomLogin__actions">
                            <button
                                type="button"
                                className="CustomLogin__sso-button"
                                onClick={handleLoginClick}
                            >
                                {buttonText}
                            </button>
                        </div>
                    </div>
                </div>

                {/* Absolute Gallery Overlay aligned perfectly to DecorativeLines Grid */}
                <div className="CustomLogin__photo-overlay">
                    {/* Photo 1: Top-Right (Cols 10-11, Rows 2-3, i.e., 2nd box unit from right edge) */}
                    <div className="CustomLogin__photo-box CustomLogin__photo-box--top-right">
                        <div
                            className="CustomLogin__photo-card"
                            style={{
                                backgroundImage: `url(${loginImages.right_image})`,
                            }}
                        />
                    </div>

                    {/* Photo 2: Bottom-Left diagonal (Cols 8-9, Rows 4-5) */}
                    <div className="CustomLogin__photo-box CustomLogin__photo-box--bottom-left">
                        <div
                            className="CustomLogin__photo-card"
                            style={{
                                backgroundImage: `url(${loginImages.left_image})`,
                            }}
                        />
                    </div>
                </div>
            </div>
        </LayoutContent>
    );
};

export default CustomLogin;
